import React from 'react';
import { Form } from 'react-bootstrap';
import { countWords } from './wizardConstants';
import { useJobWizard } from './JobWizardContext';

export default function Step3Description() {
  const { form, stepErrors: errors, updateForm: onChange } = useJobWizard();
  const wordCount = countWords(form.description);

  return (
    <div className="rwm-wizard-step">
      <h2 className="rwm-wizard-step__title">Description</h2>
      <p className="rwm-wizard-step__intro text-muted">
        Describe the role, team, and impact. Minimum 100 words required before submit.
      </p>

      <Form.Group className="mb-2">
        <Form.Label htmlFor="rwm-wizard-3-description">Job description</Form.Label>
        <Form.Control
          id="rwm-wizard-3-description"
          as="textarea"
          rows={14}
          value={form.description}
          onChange={(e) => onChange('description', e.target.value)}
          isInvalid={Boolean(errors.description)}
          data-testid="rwm-wizard-3-description"
        />
        <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
      </Form.Group>

      <p
        className={`rwm-wizard-step__word-count small mb-0 ${wordCount >= 100 ? 'text-success' : 'text-muted'}`}
        data-testid="rwm-wizard-3-word-count"
      >
        {wordCount} / 100 words minimum
      </p>
    </div>
  );
}
